module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-vector-0e251f518549e4b000db2ee845ae9fab.jpg";